import { api } from './index'

// Public endpoints: no login needed, so help also works before sign in
const helpApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getHelpArticles: builder.query({
      query: ({ platform, context } = {}) => ({
        url: '/help/articles',
        params: { platform, context },
      }),
    }),
    getHelpArticle: builder.query({
      query: (slug) => ({ url: `/help/articles/${slug}` }),
    }),
    searchHelp: builder.query({
      query: ({ q, platform }) => ({
        url: '/help/search',
        params: { q, platform },
      }),
    }),
  }),
})

export const { useGetHelpArticlesQuery, useGetHelpArticleQuery, useSearchHelpQuery } = helpApiSlice
